import {GetterTree, Module, MutationTree} from "vuex";
import {saatGecerliMi} from "@/services/senkronPlanGovde";

/**
 * Senkron bildirim saatleri (Faz 3, Ö-P3 kararı: PLAN BAŞINA DEĞİL, genel ayar).
 *
 * `senkron_plan` tablosunda bu iki saat için kolon YOK ve bilerek eklenmedi:
 * ön-kontrol ve sabah raporu istemci tarafı bildirimlerdir (F3-D5, çekme modeli),
 * bilgisayar başına anlamlıdır ve sunucuya taşınırsa iki bilgisayarda çalışan
 * aynı kullanıcı için çelişir. Bu yüzden localStorage'da durur.
 *
 * Desen `GorevYoneticisi.initAutoPlay`/`updateAutoPlay` ile aynı: okuma/yazma
 * mutation'ın içinde. (O dosya Faz 3'te DEĞİŞTİRİLMEZ; yalnız deseni alındı.)
 */

export const ON_KONTROL_SAATI_ANAHTARI = "senkronOnKontrolSaati";
export const SABAH_RAPORU_SAATI_ANAHTARI = "senkronSabahRaporuSaati";

/** Plan §6-İP6: ön-kontrol varsayılanı 22:45. */
export const VARSAYILAN_ON_KONTROL_SAATI = "22:45";
/** Plan §6-İP7: sabah raporu varsayılanı 08:00. */
export const VARSAYILAN_SABAH_RAPORU_SAATI = "08:00";

export interface SenkronAyarlariState {
    onKontrolSaati: string;
    sabahRaporuSaati: string;
}

/**
 * localStorage'dan okur; kayıt yoksa varsayılanı TOHUMLAR (autoPlay deseni).
 * Bozuk/geçersiz bir değer (elle düzenlenmiş depolama, eski sürüm kalıntısı)
 * varsayılana düşer — aksi halde zamanlayıcı `NaN` saatle hiç ateşlemezdi.
 */
function saatiOku(anahtar: string, varsayilan: string): string {
    try {
        const deger = localStorage.getItem(anahtar);
        if (deger && saatGecerliMi(deger)) return deger;
        if (!deger) localStorage.setItem(anahtar, varsayilan);
        return varsayilan;
    } catch (e) {
        // localStorage kapalıysa ayar oturumluk olur; zamanlayıcı yine çalışır.
        return varsayilan;
    }
}

function saatiYaz(anahtar: string, deger: string): void {
    try {
        localStorage.setItem(anahtar, deger);
    } catch (e) {
        console.warn("Senkron bildirim saati kaydedilemedi:", e);
    }
}

const state = (): SenkronAyarlariState => ({
    onKontrolSaati: VARSAYILAN_ON_KONTROL_SAATI,
    sabahRaporuSaati: VARSAYILAN_SABAH_RAPORU_SAATI
});

const mutations: MutationTree<SenkronAyarlariState> = {
    /** Uygulama açılışında bir kez (`App.vue` `created`). */
    INIT(state) {
        state.onKontrolSaati = saatiOku(ON_KONTROL_SAATI_ANAHTARI, VARSAYILAN_ON_KONTROL_SAATI);
        state.sabahRaporuSaati = saatiOku(
            SABAH_RAPORU_SAATI_ANAHTARI,
            VARSAYILAN_SABAH_RAPORU_SAATI
        );
    },
    SET_ON_KONTROL_SAATI(state, saat: string) {
        if (!saatGecerliMi(saat)) return;
        state.onKontrolSaati = saat;
        saatiYaz(ON_KONTROL_SAATI_ANAHTARI, saat);
    },
    SET_SABAH_RAPORU_SAATI(state, saat: string) {
        if (!saatGecerliMi(saat)) return;
        state.sabahRaporuSaati = saat;
        saatiYaz(SABAH_RAPORU_SAATI_ANAHTARI, saat);
    }
};

const getters: GetterTree<SenkronAyarlariState, any> = {
    onKontrolSaati: (state) => state.onKontrolSaati,
    sabahRaporuSaati: (state) => state.sabahRaporuSaati
};

const senkronAyarlari: Module<SenkronAyarlariState, any> = {
    namespaced: true,
    state,
    getters,
    mutations
};

export default senkronAyarlari;
